import {
  buildAawzDriveState,
  mergeAawzDriveState,
  deleteAawzDriveState,
  updateAawzDriveItemById,
} from '@modules/aawz-drive/utils/aawz-drive'
import { DEFAULT_ALLOWED_EXTENSIONS } from '@modules/aawz-drive/constants/Text'

export const SET_AAWZ_DRIVE = (state, payload) => {
  const nextData = buildAawzDriveState(state.aawzDrive.data, payload)
  if (!nextData) {
    return
  }

  state.aawzDrive.data = nextData
  state.aawzDrive.lastUpdate = new Date()
}

export const ADD_AAWZ_DRIVE = (state, payload) => {
  const nextData = mergeAawzDriveState(state.aawzDrive.data, payload)
  if (!nextData) {
    return
  }

  state.aawzDrive.data = nextData
}

export const DELETE_AAWZ_DRIVE = (state, payload) => {
  const nextData = deleteAawzDriveState(state.aawzDrive.data, payload)
  if (!nextData) {
    return
  }

  state.aawzDrive.data = nextData
}

export const RENAME_AAWZ_DRIVE_ITEM = (state, payload) => {
  const nextData = updateAawzDriveItemById(state.aawzDrive.data, payload)
  if (!nextData) {
    return
  }

  state.aawzDrive.data = nextData
}

export const SET_AAWZ_DRIVE_STORAGE = (state, payload) => {
  const storage = payload && payload.storage
  if (!storage) {
    return
  }

  const key =
    payload.rootKey !== null && payload.rootKey !== undefined
      ? String(payload.rootKey)
      : 'default'
  const currentData = state.aawzDrive.data || {}
  const currentRoot = currentData[key]

  if (!currentRoot || typeof currentRoot !== 'object') {
    return
  }

  const nextRoot = {
    ...currentRoot,
    size:
      storage.size !== undefined && storage.size !== null
        ? storage.size
        : currentRoot.size,
    total_available:
      storage.total_available !== undefined && storage.total_available !== null
        ? storage.total_available
        : currentRoot.total_available,
    storage: {
      ...(currentRoot.storage || {}),
      ...storage,
    },
  }

  state.aawzDrive.data = {
    ...currentData,
    [key]: nextRoot,
  }
}

export const SET_AAWZ_DRIVE_LOADING = (state, payload) => {
  state.aawzDrive.loading = payload
}

export const SET_AAWZ_DRIVE_UPLOAD_LOADING = (state, payload) => {
  state.aawzDrive.uploadLoading = payload
}

export const SET_AAWZ_DRIVE_ALLOWED_EXTENSIONS = (state, payload) => {
  const extensions = payload && payload.value && payload.value.extensions
  if (!extensions) {
    state.aawzDrive.allowedExtensions = DEFAULT_ALLOWED_EXTENSIONS
    return
  }

  state.aawzDrive.allowedExtensions = extensions
}
